var _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "treeGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2E7D6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1D5D4D"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8, 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 32,
    width: 8,
    height: 12,
    rx: 1,
    fill: "#8B5A2B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 28,
    rx: 18,
    ry: 10,
    fill: "url(#treeGrad)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 20,
    rx: 14,
    ry: 9,
    fill: "#3A9B87"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 13,
    rx: 10,
    ry: 7,
    fill: "#4AAA96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 25,
    r: 2.5,
    fill: "#E8853B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 25,
    r: 2.5,
    fill: "#E8853B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 18,
    r: 2.5,
    fill: "#E8853B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 14,
    r: 2,
    fill: "#F5A55A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 14,
    r: 2,
    fill: "#F5A55A"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 28,
    fontFamily: "Georgia, serif",
    fontSize: 14,
    fontWeight: "bold",
    fill: "#2E7D6B"
  }, "\n    The Pearson Clan\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 44,
    fontFamily: "Georgia, serif",
    fontSize: 10,
    fill: "#5D6D7E"
  }, "\n    Family Network\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4da23a70893ef53e3d40d7f05a923a96.svg";
export { ForwardRef as ReactComponent };